import { parse } from 'date-fns'

import { ArtistConcert } from 'shared/__gql-types'
import { useLoading, useServerError } from 'shared/hooks'

import { useGetOpusIdQuery } from '../graphql/getOpusId.types'
import { useGetUpcomingArtistConcertsQuery } from '../graphql/getUpcomingArtstConcerts.types'

export const useTour = (projectId: string | undefined) => {
  const {
    data: opusIdResponse,
    error: opusIdError,
    loading: opusIdLoading
  } = useGetOpusIdQuery({
    variables: {
      id: projectId as string
    }
  })

  const opusId = opusIdResponse?.getCampaign?.artist?.opus_id ?? ''
  const {
    data: toursResponse,
    error: tourDatesError,
    loading: tourDatesLoading
  } = useGetUpcomingArtistConcertsQuery({
    variables: {
      artistId: opusId
    },
    skip: !opusId
  })

  useLoading({ isLoading: tourDatesLoading || opusIdLoading })
  useServerError([tourDatesError, opusIdError])

  const concerts: ArtistConcert[] = toursResponse?.getUpcomingArtistConcerts?.concerts.map((concert) => (
    {
      ...concert,
      date: parse(concert.date, 'dd/MM/yyyy', new Date()).toString()
    }
  )) ?? []
  const total = toursResponse?.getUpcomingArtistConcerts?.totalConcertCount ?? 0

  return {
    concerts: concerts,
    total: total
  }
}
